import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup, Input, Label, InputGroup, Alert } from 'reactstrap'
import { getHotAcidDensityLevels, densityCorrection } from '../../../formulas/densityCorrection';

export default class DensityCorrectionForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hasResult: false,
            hasError: false,
            error: ''
        }
    }

    componentDidMount = () => {
        this.props.formToState({ hotAcidityDensityLevels: getHotAcidDensityLevels() }) // Redux, mise en place du tableau
        this.setState({ hasResult: false, hasError: false })
    }

    calculateDensityCorrection = (e) => {
        e.preventDefault()
        e.stopPropagation()
        try {
            if (this.props.densityCorrectionValues.mesuredDensity && this.props.densityCorrectionValues.mesuredTemperature && this.props.densityCorrectionValues.desiredTemperature) {
                const correction = densityCorrection(
                    this.props.densityCorrectionValues.mesuredTemperature,
                    this.props.densityCorrectionValues.mesuredDensity,
                    this.props.densityCorrectionValues.desiredTemperature) // Calcul de la correction
                this.props.formToState({ densityCorrection: correction }) // Redux
                this.setState({ hasResult: true, hasError: false })
            } else {
                throw e
            }
        } catch (e) {
            this.setState({ hasError: true, error: 'Impossible calculation' })
        }
    }

    handleChange = (e) => {
        const target = e.target
        this.props.formToState({ [target.name]: parseFloat(target.value) }) // Redux
        this.setState({ hasResult: false, hasError: false })
    }

    render() {
        return (
            <Form onSubmit={this.calculateDensityCorrection}>
                {/** Table */}
                {/*                 <p className="text-center">Table of range</p>
                {this.props.densityCorrectionValues.hotAcidityDensityLevels ?
                    <Table responsive bordered>
                        <thead>
                            <tr>
                                {this.props.densityCorrectionValues.hotAcidityDensityLevels.map((level, key) => {
                                    return (
                                        <td key={key}>
                                            <div className="density-correction-table">
                                                <p className="density-correction-range">from {level.from} to {level.to}</p>
                                                <p className="density-correction-value">+{level.correction} per °C</p>
                                            </div>
                                        </td>
                                    )
                                })}
                            </tr>
                        </thead>
                    </Table>
                    : null} */}
                {/** Form */}
                <br />
                <FormGroup>
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="mesuredDensity">Measured density <b>(kg/L)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.00001" required type="number" name="mesuredDensity" id="mesuredDensity" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="mesuredTemperature">Measured temperature <b>(°C)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.00001" required type="number" name="mesuredTemperature" id="mesuredTemperature" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                    <InputGroup>
                        <div className="col-md-8">
                            <Label for="desiredTemperature">Desired temperature <b>(°C)</b></Label>
                        </div>
                        <div className="col-md-4">
                            <Input step="0.00001" required type="number" name="desiredTemperature" id="desiredTemperature" onChange={this.handleChange} />
                        </div>
                    </InputGroup>
                    <br />
                </FormGroup>
                <Input type="submit" value="Calculate density correction" className="custom-button" onClick={this.calculateDensityCorrection} />
                <br />
                {/** Résultat */}
                {this.state.hasResult ?
                    <div className="formula-result text-center">
                        Density at {this.props.densityCorrectionValues.desiredTemperature}°C is {this.props.densityCorrectionValues.densityCorrection.correctedDensity} kg/L
                        (Correction of {this.props.densityCorrectionValues.densityCorrection.correction})
                    </div>
                    : null}
                {/** Error */}
                {this.state.hasError ?
                    <div className="text-center">
                        <Alert color="danger">
                            {this.state.error}
                        </Alert>
                    </div>
                    : null}
            </Form>
        )
    }
}

DensityCorrectionForm.propTypes = {
    densityCorrectionValues: PropTypes.shape({
        mesuredTemperature: PropTypes.number,
        mesuredDensity: PropTypes.number,
        desiredTemperature: PropTypes.number,
        densityCorrection: PropTypes.object,
        hotAcidityDensityLevels: PropTypes.arrayOf(PropTypes.shape({
            from: PropTypes.number,
            to: PropTypes.number,
            correction: PropTypes.number
        }))
    }),
    formToState: PropTypes.func
}
DensityCorrectionForm.defaultProps = {
    densityCorrectionValues: {
        hotAcidityDensityLevels: [],
        mesuredTemperature: 0,
        mesuredDensity: 0,
        desiredTemperature: 1,
        densityCorrection: 0,
    }
}